export class DBResourceMetadata {
    'resourceId';
    'resourceName';
    'resourceType';
    'resourceGroup';
    'cloudProvider';
    'environment';
    'tags';
    'apps';
    'dataClassification';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "resourceId",
            "baseName": "resourceId",
            "type": "string",
            "format": ""
        },
        {
            "name": "resourceName",
            "baseName": "resourceName",
            "type": "string",
            "format": ""
        },
        {
            "name": "resourceType",
            "baseName": "resourceType",
            "type": "ResourceType",
            "format": ""
        },
        {
            "name": "resourceGroup",
            "baseName": "resourceGroup",
            "type": "string",
            "format": ""
        },
        {
            "name": "cloudProvider",
            "baseName": "cloudProvider",
            "type": "Provider",
            "format": ""
        },
        {
            "name": "environment",
            "baseName": "environment",
            "type": "Environment",
            "format": ""
        },
        {
            "name": "tags",
            "baseName": "tags",
            "type": "{ [key: string]: string; }",
            "format": ""
        },
        {
            "name": "apps",
            "baseName": "apps",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "dataClassification",
            "baseName": "dataClassification",
            "type": "Array<DataClass>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return DBResourceMetadata.attributeTypeMap;
    }
    constructor() {
    }
}
